<template>
  <div class="partner-comment-list">
    <edi-comments-title>Estos son los comentarios de nuestros socios y socias</edi-comments-title>
    <div class="wrapper">
      <edi-slider v-if="showComments">
        <edi-partner-comment-list-item
          v-for="(item, index) in comments"
          v-if="index < 3"
          :key="index"
          :num="item.threadRelativeCommentId"
          :text="item.text"
          :user-name="item.userName"
          :user-profile-url="item.user.profileUrl"
        />
      </edi-slider>
      <div class="buttons-wrapper">
        <a
          :href="partnerUrl"
          class="partner-btn"
          v-if="!isPartner"
        >Hazte socio/a tú también y únete a la conversación</a>
        <a
          :href="loginUrl"
          class="sign-up hide-in-mobile"
          v-if="!isLogged"
        >O inicia sesión si ya lo eres</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import EdiPartnerCommentListItem from '../partner/EdiPartnerCommentListItem';
  import EdiCommentsTitle from '../EdiCommentsTitle';
  import { EdiSlider } from '../../../components';

  export default {
    name: 'edi-partner-comment-list',
    components: {
      EdiPartnerCommentListItem,
      EdiCommentsTitle,
      EdiSlider,
    },
    props: {
      comments: Array,
      siteId: Number
    },
    data() {
      return {
        showComments: true,
      }
    },
    computed: {
      ...mapGetters([
        'isLogged',
        'isPartner',
        'loginUrl',
        'partnerUrl'
      ])
    },
    methods: {
      clickLogin() {
        window.location.href = this.loginUrl;
      },
      clickPartner() {
        window.location.href = this.partnerUrl;
      }
    },
    watch: {
      /**
       * IMPORTANTE:
       * ÑAPA infernal derivada de esta issue https://mgr.bitban.com/issues/69699
       * Actualmente el plugin de jquery para pintar 'carruseles' (aka sliders) en
       * la aplicación es https://owlcarousel2.github.io/OwlCarousel2/ y
       * concretamente para la app de vue usamos un wrapper sobre este plugin
       * https://github.com/s950329/vue-owl-carousel
       *
       * El problema era el siguiente: cuando se insertaba un comentario de socio
       * en el slider, si el número total de comentarios cambiaba de `n` a `n + m`
       * Siendo:
       * - n : el número de comentarios de socio en la inicialización
       * - m : el número de comentarios añadidos
       * Los comentarios excedentes se pintaban verticalmente en lugar de horizontalmente.
       *
       * Se intentó usar el API expuesta por el plugin y los eventos emitidos por el mismo,
       * desde el propio wrapper de Vue y desde el mismo plugin de owl. Resultando en fracaso
       * en ambas opciones xDD
       *
       * ej (pseudo code, entiendase $owl.owlCarousel como la instancia de jquery
       * también se intentó con `owl.blabla directamente, sin owl.owlCarousel)
       *
       * ```
       * $owl.owlCarousel.reinit() o $owl.owlCarousel.data().reinit() o
       * $owl.owlCarousel.trigger('refresh.owl.carousel'), blabla
       * ```
       *
       * Así que al final se ha optado por modificar la variable que controla el pintado
       * del slider y seguidamente volver a activarlo. Para forzar a renderizar el componente
       * de slider y "reinicializar" el plugin de owl.
       *
       * Si has llegado hasta aquí, lamento mucho no haber encontrado otra opción,
       * he perdido alrededor de 80 IQ y unas 6 horas indagando en el source code del
       * plugin de owl, issues de github, y preguntas de stack overflow.
       */
      comments() {
        this.showComments = false;
        this.$nextTick(() => {
          this.showComments = true;
        });
      },
    },
  }
</script>
